// import React, { useState } from "react";  
// import { Link } from "react-router-dom";  
// import "./navbar.css";  
// import profileLogo from '../images/Profile.png';   
  
// export default function Navbar() {  
//     const [isMenuOpen, setMenuOpen] = useState(false);  
//     const [isDropdownOpen, setDropdownOpen] = useState(false);  
  
//     function toggleMenu() {  
//         setMenuOpen((prevState) => !prevState);  
//     }  
  
//     function toggleDropdown() {  
//         setDropdownOpen((prevState) => !prevState);  
//         if (isMenuOpen) {  
//             setMenuOpen(false);  
//         }  
//     }  
  
//     function handleClick() {  
//         setMenuOpen(false);  
//         setDropdownOpen(false);  
//     }  
  
//     function DropdownClick() {  
//         setDropdownOpen((prevState) => !prevState);  
//         setMenuOpen(false);  
//     }  
  
//     return (  
//         <nav className="navbar">  
//             <div className="menu-btn" onClick={toggleMenu}>  
//                 <div className="menu-btn__burger"></div>  
//             </div>  
//             <div className={`sliding-menu ${isMenuOpen ? "show" : ""}`}>  
//                 <div className="close-btn" onClick={toggleMenu}>  
//                     &times;  
//                 </div>  
//                 <ul>  
//                     {/* <li>  
//                         <Link to="/dashboard" onClick={handleClick}>Dashboard</Link>  
//                     </li>   */}
//                     <li>  
//                         <Link to="/broadcastmessage" onClick={handleClick}>Broadcast</Link>  
//                     </li>  
//                     <li>  
//                         <Link to="/kpidetails" onClick={handleClick}>KPI</Link>  
//                     </li>  
//                     <li>  
//                         <Link to="/feedback" onClick={handleClick}>Feedback</Link>  
//                     </li>  
//                     <li>  
//                         <Link to="/km-analysis" onClick={handleClick}>KM Analysis</Link>  
//                     </li>  
//                 </ul>  
//             </div>  
//             <div className="profile-section">  
//                 <img  
//                     src={profileLogo}  
//                     alt="Profile"  
//                     className="profile-icon"  
//                     onClick={toggleDropdown}  
//                 />  
//                 {isDropdownOpen && (  
//                     <div className="dropdown-menu">  
//                         {/* <Link to="/profile" className="dropdown-item" onClick={DropdownClick}>  
//                             Profile  
//                         </Link>   */}
//                         <Link to="/" className="dropdown-item" onClick={DropdownClick}>  
//                             Logout  
//                         </Link>  
//                     </div>  
//                 )}  
//             </div>  
//         </nav>  
//     );  
// }  

import React, { useState ,useEffect } from "react";
import { Link } from "react-router-dom";
import "./navbar.css";
import profileLogo from '../images/Profile.png';
import appLogo from "../Webpage/utils/outline.png";
import { NavLink } from "react-router-dom";

export default function Navbar() {
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  function toggleDropdown() {
    setDropdownOpen((prev) => !prev);
  }

  function closeDropdown() {
    setDropdownOpen(false);
  } 

  return (
    <nav className="navbar">
      {/* Left: Logo */}
          <div className="navbar-left" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
              <div>
                  <img src={appLogo} alt="Logo" className="app-logo" />
              </div>
                <div style={{width:"20px"}}></div>
              {/* Center: Navigation */}
              <ul className="navbar-links">
                  <li>
                      <NavLink
                          to="/broadcastmessage"
                          className={({ isActive }) => (isActive ? "active-link" : "")}
                      >
                          Broadcast
                      </NavLink>
                  </li>

                  <li>
                      <NavLink
                          to="/kpidetails"
                          className={({ isActive }) => (isActive ? "active-link" : "")}
                      >
                          KPI
                      </NavLink>
                  </li>

                  <li>
                      <NavLink
                          to="/feedback"
                          className={({ isActive }) => (isActive ? "active-link" : "")}
                      >
                          Feedback
                      </NavLink>
                  </li>

                  <li>
                      <NavLink
                          to="/kmanalysis"
                          className={({ isActive }) => (isActive ? "active-link" : "")}
                      >
                          KM Analysis
                      </NavLink>
                  </li>

                  <li>
                      <NavLink
                          to="/transcript"
                          className={({ isActive }) => (isActive ? "active-link" : "")}
                      >
                          Transcript
                      </NavLink>
                  </li>
              </ul>

          </div>
      {/* Right: Profile */}
      <div className="navbar-right">
        <img
          src={profileLogo}
          alt="Profile"
          className="profile-icon"
          onClick={toggleDropdown}
        />

        {isDropdownOpen && (
          <div className="dropdown-menu">
            <Link to="/" onClick={()=>{
                closeDropdown();
            }} className="dropdown-item">
              Logout
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
